import Service, { service } from '@ember/service';
import { restartableTask } from 'ember-concurrency';
import appointmentBranchSettingsQuery from 'my-phorest/gql/queries/appointment-branch-settings.graphql';
import { variation } from 'ember-launch-darkly';

export default class AppointmentBranchSettingsService extends Service {
  @service apollo;
  @service session;

  @restartableTask
  *fetchAppointmentSettingsTask() {
    return yield this.apollo.query({
      query: appointmentBranchSettingsQuery,
      variables: { branchId: this.session.branch.id },
    });
  }

  get showFlagForIncompleteClient() {
    if (!variation('release-complete-client-toggle')) {
      return false;
    }
    return this.fetchAppointmentSettingsTask.lastSuccessful?.value
      ?.appointmentBranchSettings?.showFlagForIncompleteClient;
  }
}
